import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeEbbeModalCallback } from '../../../redux/reducers/authSlice';
import TableFooter, { TUMU_TAKE } from '../../../components/TableFooter';
import { filtreAnahtari, hepsiniEkle, kayitSecimiDegistir, sayfaSecimiDegistir, Secim, secimOzeti } from '../../../helpers/sayfalarArasiSecim';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetWillInvoicedListPagingAndFilterRequest, initialGetWillInvoicedListPagingAndFilterRequest } from '../../../models/request/invoice/GetWillInvoicedListPagingAndFilterRequest';
import { GetWillInvoicedListPagingAndFilterResponse, GetWillInvoicedListPagingAndFilterResponseData, GetWillInvoicedListPagingAndFilterResponseItem, initialGetWillInvoicedListPagingAndFilterResponseData } from '../../../models/response/invoice/GetWillInvoicedListPagingAndFilterResponse';
import { InvoiceService } from '../../../services/InvoiceService';
import WillInvoicedListFilters from './Components/WillInvoicedListFilters';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { ExportWillInvoicedListResponse } from '../../../models/response/invoice/ExportWillInvoicedListResponse';
import { ModuleEnum, VehicleStatusEnum } from '../../../models/common/Enums';
import { AddInvoiceResponse } from '../../../models/response/invoice/AddInvoiceResponse';
import { GroupInvoiceDetailsResponse } from '../../../models/response/invoice/GroupInvoiceDetailsResponse';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadConstantsByCode, loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { CompanyService } from '../../../services/CompanyService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ServiceService } from '../../../services/ServiceService';
import { dipToplam, FARKLI_DOVIZ } from '../../../helpers/dipToplam';
import { topluFaturaSiparisleri } from '../../../helpers/topluFatura';

const WillInvoicedList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ön Muhasebe > Faturalanacaklar"
    // Surum 3 (06.10.2026): yeni kolonlar ve kolon adlari; eski kolon secici ayari sifirlansin.
    const pageVersion = "3";
    const [data, setData] = useState<GetWillInvoicedListPagingAndFilterResponseData>(initialGetWillInvoicedListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetWillInvoicedListPagingAndFilterRequest>(initialGetWillInvoicedListPagingAndFilterRequest);
    // Sayfalar arası seçim (19.10.2026): seçilen kayıtlar sayfa değişince korunur; filtre / arama değişince temizlenir.
    const [secilenler, setSecilenler] = useState<Secim<GetWillInvoicedListPagingAndFilterResponseItem>>({});
    const sonFiltreAnahtari = useRef<string | null>(null);
    const kayitId = (x: GetWillInvoicedListPagingAndFilterResponseItem) => x.expectedIncomeOutcomeId;

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Modül', name: 'moduleName', order: 0, isVisible: true },
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Tedarikçi', name: 'supplierName', order: 0, isVisible: true },
            { title: 'Alıcı Firma', name: 'receiverFirmName', order: 0, isVisible: true },
            // Belge No: Nakliye'de Taşıma İrsaliyesi, Yurtiçi Kargo'da Belge No (06.10.2026).
            { title: 'Bölüm', name: 'divisionName', order: 0, isVisible: true },
            { title: 'PO', name: 'poName', order: 0, isVisible: true },
            { title: 'PO Numarası', name: 'poNo', order: 0, isVisible: true },
            { title: 'Belge No', name: 'documentNo', order: 0, isVisible: true },
            { title: 'Gönderi Kodu', name: 'shippingCode', order: 0, isVisible: true },
            { title: 'T. Ücret Ağırlığı', name: 'totalPriceWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'Toplam Tutar', name: 'totalWithoutTaxPrice', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'T. Brüt Tutar', name: 'totalPrice', order: 0, isVisible: true, className: 'custom-text-right' }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetWillInvoicedListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            // Filtre ya da arama değiştiyse (sayfa / sayfa boyu dışında) önceki seçim geçersiz.
            const anahtar = filtreAnahtari(_filter);
            if (sonFiltreAnahtari.current != null && sonFiltreAnahtari.current != anahtar)
                setSecilenler({});
            sonFiltreAnahtari.current = anahtar;

            dispatch(storeActivityIndicator(true))

            var response: GetWillInvoicedListPagingAndFilterResponse = await InvoiceService.getWillInvoicedListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (InvoiceManager.ApplyWillInvoicedColumnFilters) aynı. Liste sunucuda bellekte
    // üretildiği için filtre orada, sayfalamadan önce uygulanır.
    // Tedarikçi ve Alıcı Firma metinle aranır: Ambar'da tedarikçi seferdeki ad olarak tutuluyor.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        moduleName: { type: 'select', allowEmpty: false, loadOptions: () => loadConstants('MODULE') },
        refNo: { type: 'text' },
        customerName: { type: 'select', allowEmpty: false, loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        supplierName: { type: 'text' },
        receiverFirmName: { type: 'text' },
        divisionName: { type: 'select', loadOptions: () => loadConstants('DIVISION') },
        poName: { type: 'select', loadOptions: () => loadList(ServiceService.getServiceList(true), 'serviceId', x => x.name) },
        poNo: { type: 'text' },
        documentNo: { type: 'text' },
        shippingCode: { type: 'text' },
        totalPriceWeight: { type: 'number' },
        currencyTypeName: { type: 'select', allowEmpty: false, loadOptions: () => loadConstantsByCode('CURRENCY') },
        totalWithoutTaxPrice: { type: 'number' },
        totalPrice: { type: 'number' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const setItemSelected = (_id: string) => {
        const kayit = data.items.find(x => x.expectedIncomeOutcomeId == _id);
        if (kayit)
            setSecilenler(s => kayitSecimiDegistir(s, _id, kayit));
    }

    // Başlıktaki kutu: bu sayfadakileri seçer ya da çıkarır; diğer sayfaların seçimi korunur.
    const selectAll = () => {
        setSecilenler(s => sayfaSecimiDegistir(s, data.items, kayitId));
    }

    // Filtredeki bütün kayıtları (kaç sayfa olursa olsun) seçer.
    const filtredekiTumunuSec = async () => {
        try {
            dispatch(storeActivityIndicator(true))
            var response: GetWillInvoicedListPagingAndFilterResponse = await InvoiceService.getWillInvoicedListPagingAndFilter({ ...filter, skip: 0, take: TUMU_TAKE, currentPage: 1 });
            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }
            setSecilenler(s => hepsiniEkle(s, response.data.items, kayitId));
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const ozet = secimOzeti(secilenler, data.items, kayitId, data.totalRecordCount);
    const seciliKayitlar = Object.values(secilenler);

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportWillInvoicedListResponse = await InvoiceService.exportWillInvoicedList(buildExcelRequest(filter, mode, Object.keys(secilenler), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getColumnValue = (item: GetWillInvoicedListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "refNo") {
            if (item.moduleKey == ModuleEnum.AMBAR) {
                return (
                    <td className={className} onClick={() => setItemSelected(item.expectedIncomeOutcomeId)}><a onClick={(e) => { e.stopPropagation(); window.open(window.location.href.replace("willinvoiced", "ambar") + "add?id=" + item.orderId, "_blank"); }} href='javascript:;'>{item.refNo}</a></td>
                )
            }
            else if (item.moduleKey == ModuleEnum.ULUSLARARASI_KARA) {
                return (
                    <td className={className} onClick={() => setItemSelected(item.expectedIncomeOutcomeId)}><a onClick={(e) => { e.stopPropagation(); window.open(window.location.href.replace("willinvoiced", "landorder") + "add?id=" + item.orderId, "_blank"); }} href='javascript:;'>{item.refNo}</a></td>
                )
            }
            else if (item.moduleKey == ModuleEnum.YURTICI_KARGO) {
                return (
                    <td className={className} onClick={() => setItemSelected(item.expectedIncomeOutcomeId)}><a onClick={(e) => { e.stopPropagation(); window.open(window.location.href.replace("willinvoiced", "yurticicargo") + "add?id=" + item.orderId, "_blank"); }} href='javascript:;'>{item.refNo}</a></td>
                )
            }
        }
        else if (["totalPriceWeight", "totalWithoutTaxPrice", "totalPrice"].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.expectedIncomeOutcomeId)}>{Helpers.correctPrice(item2[column])}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.expectedIncomeOutcomeId)}>{item2[column]}</td>;
        }
    }

    // Dip toplam (06.10.2026): görüntülenen satırların toplamı; farklı döviz cinsi varsa toplam yerine uyarı.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        if (columnIndex == 0)
            return <td className={className}>Toplam</td>;

        if (["totalPriceWeight", "totalWithoutTaxPrice", "totalPrice"].includes(columnName)) {
            const sonuc = dipToplam(data.items, (x: any) => x[columnName], x => x.currencyTypeName);
            return <td className={className}>{sonuc.farkliDoviz ? FARKLI_DOVIZ : Helpers.correctPrice(sonuc.toplam, 2)}</td>;
        }

        return <td className={className}></td>;
    }

    const onCreateInvoice = async (isSale: boolean, isGroup: boolean) => {
        try {
            var ignoreWithholding: boolean | undefined = undefined;

            var selectedItems = seciliKayitlar;

            if (selectedItems.length == 0)
                return;


            if ([...new Set(selectedItems.map(x => x.customerId))].length > 1) {
                toast.error('Lütfen tek müşteri seçiniz.');
                return;
            }

            // if (selectedItems.find(x => x.isWithholding)) {
            //     if ([...new Set(selectedItems.map(x => x.vehicleStatusKey))].length > 1) {
            //         toast.error('Birden fazla araç durumu olan siparişlere aynı anda fatura kesemezsiniz.');
            //         return;
            //     }

            //     if (selectedItems.find(x => !Helpers.isEmpty(x.vehicleStatusKey) && x.vehicleStatusKey != VehicleStatusEnum.OZMAL)) {
            //         toast.error('Birden fazla araç durumu olan siparişlere aynı anda fatura kesemezsiniz.');
            //         return;
            //     }
            // }

            if ([...new Set(selectedItems.map(x => x.customerId))].length > 1) {
                toast.error('Lütfen tek müşteri seçiniz.');
                return;
            }

            if ([...new Set(selectedItems.map(x => x.currencyTypeId))].length > 1) {
                toast.error('Lütfen tek döviz cinsi seçiniz.');
                return;
            }

            var poNo = selectedItems.find(x => x.poNo);

            if (poNo) {
                if ([...new Set(selectedItems.map(x => (x.poNo)))].length > 1) {
                    toast.error('Lütfen tek po numarası seçiniz.');
                    return;
                }
            }

            dispatch(storeActivityIndicator(true));

            // Fatura siparis siparis olusturuluyor; aradaki bir hata yarim fatura birakiyordu. Once butun Nakliye
            // siparisleri kontrol edilir, sorun varsa hic fatura acilmaz (06.10.2026).
            var nakliyeSiparisleri = selectedItems.filter(x => x.moduleKey == ModuleEnum.AMBAR).map(x => x.orderId);

            if (nakliyeSiparisleri.length > 0) {
                var kontrol = await InvoiceService.checkInvoiceFromAmbars(nakliyeSiparisleri, isSale, selectedItems[0].currencyTypeId);

                if (!kontrol.isSuccess) {
                    toast.error(kontrol.message);
                    return;
                }

                if (kontrol.data && kontrol.data.length > 0) {
                    // Butun sorunlu siparisler tek uyarida, alt alta; kullanici hepsini bir seferde duzeltir.
                    toast.error(
                        <div>
                            <b>Fatura oluşturulmadı. Şu {kontrol.data.length} siparişi düzeltip tekrar deneyin:</b>
                            {kontrol.data.map((x: string, i: number) => <div key={i}>• {x}</div>)}
                        </div>,
                        { duration: 30000 }
                    );
                    return;
                }
            }

            // Tek istek, tek işlem (19.10.2026): eskiden sipariş başına istek atılıyordu (1.507 siparişte ~1 dk) ve aradaki
            // bir hata yarım fatura bırakıyordu. Sunucu faturayı ilk siparişe göre açar, satırları seçim sırasıyla ekler;
            // bir siparişte sorun varsa hiçbir şey yazılmaz.
            var siparisler = topluFaturaSiparisleri(selectedItems);

            if (siparisler.length === 0)
                return;

            var addInvoiceResponse: AddInvoiceResponse = await InvoiceService.addInvoiceFromOrders(siparisler, isSale, selectedItems[0].currencyTypeId, ignoreWithholding);

            if (!addInvoiceResponse.isSuccess) {
                toast.error(addInvoiceResponse.message)
                return;
            }

            var invoiceId: string | undefined = addInvoiceResponse.data?.invoiceId;

            if (isGroup && invoiceId) {
                var response: GroupInvoiceDetailsResponse = await InvoiceService.groupInvoiceDetails(invoiceId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }
            }

            toast.success(addInvoiceResponse.message)

            if (isSale)
                navigate(window.location.pathname.replace('willinvoiced', 'saleinvoice').replace('list', 'listadd') + '?id=' + addInvoiceResponse.data.invoiceId);
            else
                navigate(window.location.pathname.replace('willinvoiced', 'purchaseinvoice').replace('list', 'listadd') + '?id=' + addInvoiceResponse.data.invoiceId);

            // var subItems: AddInvoiceRequestInvoiceDetail[] = [];



            // var getCompanyByIdResponse: GetCompanyByIdResponse | undefined = undefined;
            // var getAmbarByIdResponse: GetAmbarByIdResponse | undefined = undefined;

            // if (filter?.selectedModule?.additionalValue1 == ModuleEnum.AMBAR) {
            //     getAmbarByIdResponse = await AmbarService.getAmbarById(selectedItem.orderId);

            //     if (!getAmbarByIdResponse)
            //         return;

            //     if (!getAmbarByIdResponse.isSuccess) {
            //         toast.error(getAmbarByIdResponse.message)
            //         return;
            //     }

            //     getCompanyByIdResponse = await CompanyService.getCompanyById(getAmbarByIdResponse.data.customerId);

            //     if (!getCompanyByIdResponse?.isSuccess) {
            //         toast.error(getCompanyByIdResponse?.message)
            //         return;
            //     }

            //     subItems = getAmbarByIdResponse.data.ambarExpectedIncomeOutcomes.filter(x => isSale ? x.isIncome : !x.isIncome).map(function (x) {
            //         return {
            //             description: x.description,
            //             quantity: x.quantity,
            //             serviceId: x.serviceId,
            //             unitPrice: x.unitPrice,
            //             exceptionId: undefined,
            //             totalWithoutTaxPrice: x.totalWithoutTaxPrice,
            //             taxRate: x.taxRate,
            //             taxPrice: x.taxPrice,
            //             totalPrice: x.totalPrice
            //         }
            //     });
            // }
            // else
            //     return;

            // if (!getCompanyByIdResponse)
            //     return;

            // if (subItems.length == 0)
            //     return;



            // if (!getCompanyByIdResponse.data.maturityPeriodId || !getCompanyByIdResponse.data.maturityPeriodKey) {
            //     toast.error('');
            //     return;
            // }

            // var invoiceDate = moment().format('YYYY-MM-DD');

            // var paymentDate = moment(invoiceDate, "YYYY-MM-DD").add('days', parseInt(getCompanyByIdResponse.data.maturityPeriodKey)).format('YYYY-MM-DD');

            // var response3: GetCurrencyConversionListResponse = await CurrencyConversionService.getCurrencyConversionList(invoiceDate);

            // if (!response3.isSuccess) {
            //     toast.error(response3.message)
            //     return;
            // }

            // var getCurrencyConstantResponse: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY', undefined, 'TRY');

            // if (!getCurrencyConstantResponse.isSuccess) {
            //     toast.error(getCurrencyConstantResponse.message)
            //     return;
            // }

            // var selectedCurrencyType = { label: getCurrencyConstantResponse.data[0].value, value: getCurrencyConstantResponse.data[0].constantId };

            // var currency = response3.data.find(x => x.toCurrencyId == selectedCurrencyType.value);

            // var currencyRate = currency?.sellStr;

            // if (!currency) {
            //     if (selectedCurrencyType.label == "TRY") {
            //         currencyRate = "1";
            //     }
            //     else {
            //         toast.error('Seçilen tarihe ait kur bulunamadı.');
            //         return;
            //     }
            // }

            // var obj: AddInvoiceRequest = {
            //     moduleId: filter?.selectedModule?.value,
            //     currentCompanyId: getCompanyByIdResponse.data.companyId,
            //     currentCompanyAddressTypeId: defaultAdress.addressTypeId,
            //     addressText: defaultAdress.addressText,
            //     operationTypeId: undefined,
            //     invoiceCategoryId: invoiceCategoryId,
            //     invoiceStatusId: invoiceStatusId,
            //     invoiceDate: invoiceDate,
            //     serialNo: '-',
            //     paymentTypeId: getCompanyByIdResponse.data.paymentTypeId,
            //     maturityPeriodId: getCompanyByIdResponse.data.maturityPeriodId,
            //     paymentDate: paymentDate,
            //     currencyDate: invoiceDate,
            //     currencyTypeId: selectedCurrencyType.value,
            //     currency: currencyRate,
            //     transferDate: undefined,
            //     fileArchives: [],
            //     invoiceId: undefined,
            //     isSale: 1,
            //     isPurchase: 0,
            //     isRefund: 0,
            //     refNo: undefined,
            //     currencyRateTypeId: currencyRateTypeId,
            //     invoiceTypeId: invoiceTypeId,
            //     description: '-',
            //     invoiceDetails: subItems
            // }

            // var response5: AddInvoiceResponse = await InvoiceService.addInvoice(obj);

            // if (!response5.isSuccess) {
            //     toast.error(response5.message);
            //     dispatch(storeActivityIndicator(false));
            //     return;
            // }

            // if (filter?.selectedModule?.additionalValue1 == ModuleEnum.AMBAR && getAmbarByIdResponse) {
            //     getAmbarByIdResponse.data.ambarExpectedIncomeOutcomes = getAmbarByIdResponse.data.ambarExpectedIncomeOutcomes.map(function (x) {
            //         x.invoiceNo = response5.data.invoiceId;
            //         x.invoiceDate = response5.data.invoiceDate;

            //         return x;
            //     })

            //     var updateAmbarResponse = AmbarService.addAmbar(getAmbarByIdResponse);
            // }

            // // for (var i = 0; i < responseList.length; i++) {
            // //     if (!Helpers.isEmpty(responseList[i].antrepoInVehicleId) || !Helpers.isEmpty(responseList[i].antrepoOutVehicleId) || !Helpers.isEmpty(responseList[i].antrepoInVehicleServiceId) || !Helpers.isEmpty(responseList[i].antrepoOutVehicleServiceId)) {
            // //         var response6: AddAntrepoVehicleInvoiceResponse = await InvoiceService.addAntrepoVehicleInvoice({
            // //             antrepoInVehicleId: responseList[i].antrepoInVehicleId,
            // //             antrepoOutVehicleId: responseList[i].antrepoOutVehicleId,
            // //             antrepoVehicleInvoiceId: undefined,
            // //             invoiceId: response5.data.invoiceId,
            // //             antrepoInVehicleServiceId: responseList[i].antrepoInVehicleServiceId,
            // //             antrepoOutVehicleServiceId: responseList[i].antrepoOutVehicleServiceId
            // //         });

            // //         if (!response6.isSuccess) {
            // //             toast.error(response6.message);
            // //             dispatch(storeActivityIndicator(false));
            // //             return;
            // //         }
            // //     }
            // // }

            // // toast.success(response5.message);

            // navigate(window.location.pathname.replace('calculate', 'saleinvoice').replace('list', 'listadd') + '?id=' + response5.data.invoiceId);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const createInvoice = async (isSale: boolean) => {
        dispatch(storeEbbeModalCallback({
            title: 'Bilgilendirme',
            body: 'Hizmet Kalemi Gruplaması yapılsın mı?',
            buttons: [
                {
                    text: 'Vazgeç',
                    btnClass: 'btn-warning',
                },
                {
                    text: 'Hayır',
                    btnClass: 'btn-danger',
                    onClick: () => onCreateInvoice(isSale, false)
                },
                {
                    text: 'Evet',
                    btnClass: 'btn-success',
                    onClick: () => onCreateInvoice(isSale, true)
                }
            ]
        }))
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <WillInvoicedListFilters
                    columns={columns}
                    excelExport={excelExport}
                    filter={filter}
                    getColumns={getColumns}
                    getData={getData}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    setFilter={setFilter}
                    selectedCount={ozet.seciliSayisi}
                    createInvoice={createInvoice}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        {
                            ozet.seciliSayisi > 0 && (ozet.tumunuSecTeklifi || ozet.filtreTamamSecili || ozet.digerSayfalardaSecili > 0) && (
                                <div className='alert alert-primary d-flex flex-wrap align-items-center gap-2 py-2 px-4 mb-2 fs-7'>
                                    {
                                        ozet.filtreTamamSecili
                                            ? <span>Filtredeki <b>{data.totalRecordCount}</b> kaydın tümü seçili.</span>
                                            : ozet.tumunuSecTeklifi && ozet.digerSayfalardaSecili == 0
                                                ? <span>Bu sayfadaki <b>{ozet.sayfadaSecili}</b> kayıt seçili.</span>
                                                : <span><b>{ozet.seciliSayisi}</b> kayıt seçili ({ozet.digerSayfalardaSecili} tanesi diğer sayfalarda).</span>
                                    }
                                    {
                                        !ozet.filtreTamamSecili && data.totalRecordCount > data.items.length && (
                                            <button type='button' className='btn btn-link btn-sm p-0 fw-bold' onClick={filtredekiTumunuSec}>Filtredeki {data.totalRecordCount} kaydın tümünü seç</button>
                                        )
                                    }
                                    <button type='button' className='btn btn-link btn-sm p-0 text-muted' onClick={() => setSecilenler({})}>Seçimi temizle</button>
                                </div>
                            )
                        }

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table ebbe-table-fill'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={ozet.sayfaTamamSecili} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: secilenler[item.expectedIncomeOutcomeId] ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.expectedIncomeOutcomeId)} className='form-check-input' type='checkbox' checked={!!secilenler[item.expectedIncomeOutcomeId]} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı tablonun altına iner (07.10.2026). */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td style={{ width: 1 }}></td>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment key={column.name}>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={ozet.seciliSayisi}
                        tumuSecenegi
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default WillInvoicedList;